import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzInputModule } from 'ng-zorro-antd/input';``
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { debounceTime, distinctUntilChanged } from 'rxjs';


@Component({
  selector: 'hypenation-tickets-filter-bar',
  standalone: true,
  imports: [CommonModule, FormsModule, NzSelectModule, NzDatePickerModule, NzInputModule, NzIconModule, NzButtonModule, ReactiveFormsModule ],
  templateUrl: './filter-bar.component.html',
  styleUrl: './filter-bar.component.css',
})
export class FilterBarComponent implements OnInit  {

  filteringString : string | null = null;
  @Output() seachString : EventEmitter<string> = new EventEmitter<string>();
  filteringControl: FormControl = new FormControl('');


  ngOnInit(): void {
      // Set up debounce for the search input
    this.filteringControl.valueChanges
    .pipe(
      debounceTime(2000), // Wait 2 seconds after the last character typed
      distinctUntilChanged() // Only emit if the value changes
    )
    .subscribe((value: string) => {
      console.log(value);
      
      if (value && value.length >= 3) {
        this.seachString.emit(value);
      }else{
        this.seachString.emit('');
      }
    });
  }


  public filterOnEnter(): void {
    const value = this.filteringControl.value;
    if (value && value.length >= 4) {
      this.seachString.emit(value);
    }else{
      this.seachString.emit('');
    }
  }



  public filter() : void{
    if(this.filteringString && this.filteringString !== ''){
      this.seachString.emit(this.filteringString);
    } else {
      this.seachString.emit('');
    }
  }
}
